import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _identity from 'lodash/identity';
import _isFunction from 'lodash/isFunction';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Pill from 'components/Pill';
import { SvgArrow } from 'components/Svgs';

import Dropdown from './DropdownContainer';
import { DropdownPropTypes } from './Dropdown';
import Menu, { MenuPropTypes } from './Menu';
import './PillMenu.scss';

export const PillToggle = props => {
  const {
    items,
    getText,
    isSelected,
    toggleMenu,
    isOpen,
    renderSelectedItem,
    isWide,
    hasError,
    disabled,
    warn,
    danger,
    renderAsActive,
    title,
  } = props;
  let selectedItem;
  let text;
  let active;
  if (isSelected) {
    [selectedItem] = items.filter(isSelected);
    text = typeof getText === 'string' ? _get(selectedItem, getText) : getText(selectedItem);
    active = _isFunction(renderAsActive) ? renderAsActive(selectedItem) : renderAsActive;
  }

  const classes = withMods('pill-menu__toggle', { isOpen, wide: isWide });

  let arrowTheme = 'dark';
  if (disabled) {
    arrowTheme = 'disabled';
  } else if (danger) {
    arrowTheme = 'danger';
  } else if (warn) {
    arrowTheme = 'warn';
  } else if (active) {
    arrowTheme = 'brand';
  }

  let pillTheme = 'light';
  if (danger) {
    pillTheme = 'danger';
  } else if (warn) {
    pillTheme = 'warn';
  }

  return (
    <Pill
      className={classes}
      onClick={toggleMenu}
      theme={pillTheme}
      hasError={hasError}
      disabled={disabled}
      active={active}
      title={title}>
      <span className="pill-menu__toggle-text" title={title}>
        {renderSelectedItem(text, true, selectedItem, items)}
      </span>
      <SvgArrow className="pill-menu__caret" direction={isOpen ? 'up' : 'down'} theme={arrowTheme} />
    </Pill>
  );
};

PillToggle.propTypes = {
  isWide: PropTypes.bool,
  warn: PropTypes.bool,
  danger: PropTypes.bool,
  ...DropdownPropTypes,
  ...MenuPropTypes,
};

const PillMenu = ({ className, ...rest }) => (
  <Dropdown {...rest} className={withMods('pill-menu', className)} Toggle={PillToggle} Content={Menu} />
);

PillMenu.propTypes = {
  className: PropTypes.string,
  renderSelectedItem: PropTypes.func,
  // getKey and getText are part of DropdownPropTypes but the linter isn't seeing them
  getKey: PropTypes.func,
  getText: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  hasError: PropTypes.bool,
  renderAsActive: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  ...DropdownPropTypes,
  ...MenuPropTypes,
};

PillMenu.defaultProps = {
  renderSelectedItem: _identity,
  getKey: _identity,
  getText: _identity,
  renderAsActive: Boolean,
};

export default PillMenu;
